<template>
    <div>
        <div class="search-field">
            <b-dropdown v-bind:text="logNames[term]" :key="'dropdown-'+updateKey">
    			<b-dropdown-item v-for="(name,i) in logNames" v-on:click="setLog(i)" :key="index">{{name}}</b-dropdown-item>
    		</b-dropdown>
        </div>
        <div style="margin-left:50px;" class="search-field">
            <b>Display Line Count:</b>
            <input v-model="count" style="width:60px"></input>
            <button v-on:click="search()" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>
        </div>
        <div style="margin-left:50px;" class="search-field">
            <b>Download Line Count:</b>
            <input v-model="downloadCount" style="width:60px"></input>
            <button v-on:click="download(false)" style="height:30px;">Download</button>
            <button v-on:click="download(true)" style="height:30px;">Download Full File</button>
        </div>
        <!--<div style="margin-left:50px;" class="search-field">
            <b>Auto Reload:</b>
            <input v-model="reloadauto" type="checkbox" style="width:30px"></input>
        </div>-->

  		<layout-1
          :table_name="'Logs'"
          :key="'log_'+tableKey"
          :id=pageid1
          :searchbar=false
          :navbar=false
          :term=searchTerm
          :termchange=true
          :doAutoReload=false
          style="width:100%; height:calc(100vh - 110px);"
        ></layout-1>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props:{
		term: {
			type: Number,
			required: false,
			default: 0
		},
	},
	data() {
		return {
            pageid1:PAGES.LOGS_PAGE,
            pageid2:PAGES.LOGS_NAMES_PAGE,
            count:50,
            downloadCount:500,
            searchTerm:[0,50],
            logNames:[],
            updateKey:0,
            tableKey:0,
            reloadauto:true,
		}
	},
    async created () {
        this.searchTerm[0]=this.term;
        this.search();
        this.getFileNames();
    },
	methods: {
        setCount(amt){
            this.count=amt;
        },
        setLog(index){
            this.term=index;
            router.push('/0207?q='+this.term);
            this.search();
        },
        search(){
            this.searchTerm=[this.term,this.count];
            this.tableKey++;
        },
        getFileNames(){
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid2,
                        data:[
                        ],
                    }
                }
            ).then((res) => {
                this.logNames=res.data;
            })
        },
        download(fullfile) {
            var rowCount = fullfile?-1:this.downloadCount;
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid1,
                        data:[
                            [this.term,rowCount]
                        ],
                    }
                }
            ).then((res) => {
                var filename = this.logNames[this.term];
                var text = "";

                for(let i = 0;i<res.data.data.column_data.length;i++){

                    var timestamp = res.data.data.column_data[i][1];
                    var newTimestamp =
                    timestamp.substr(0,4) +
                    timestamp.substr(5,2) +
                    timestamp.substr(8,2) +
                    '-' +
                    timestamp.substr(11,2) +
                    timestamp.substr(14,2) +
                    timestamp.substr(17,2);

                    text+='[';
                    text+=newTimestamp;
                    text+='][';
                    text+=res.data.data.column_data[i][2];
                    text+='][';
                    text+=res.data.data.column_data[i][3];
                    text+='][';
                    text+=res.data.data.column_data[i][4];
                    text+=']';
                    text+='\n';
                }

                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
                element.setAttribute('download', filename);

                element.style.display = 'none';
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
            })
        }
	},
	watch:{
		term(){
			this.search();
		},
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/file/Logs.vue